import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { actions as activeAccountActions } from 'redux/slices/account';
const { clearAccount } = activeAccountActions;
import { SIGNIN_PAGE } from 'site-settings/site-navigation';
import { ButtonsGrid, Button } from 'components/common/button/button';
import { wallet } from 'utils/wallet';
import { useAppDispatch } from 'redux/use-hooks';

import { StyledContainer, StyledSection, StyledHeading } from './views.style';

const LogoutView = ({ closeModal }: { closeModal: () => void }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const signedOut = await wallet.signOut();
      // Keep session if Meteor was closed / sign-out cancelled.
      if (!signedOut) {
        return;
      }

      dispatch(clearAccount());
      navigate(SIGNIN_PAGE);
      closeModal();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledContainer>
      <StyledSection>
        <StyledHeading>Are you sure you want to Log Out ?</StyledHeading>
        <ButtonsGrid>
          <Button fullwidth onClick={closeModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            fullwidth
            variant="secondary"
            onClick={handleLogout}
            disabled={isLoading}
            loading={isLoading}
          >
            Log Out
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default LogoutView;
